import React, { forwardRef } from "react";
import Form from "react-bootstrap/Form";

const SendingType = forwardRef<HTMLSelectElement, {tabIndex: number}>(
    ({ tabIndex, ...props }, ref) => {
    return (
        <Form.Group className="form-group filter-sendingType">
            <Form.Label>
                <span className="icon"></span>
                Type
            </Form.Label>
            <Form.Select id="filters-sendingType-select" tabIndex={tabIndex} ref={ref}>
                <option value="all">Tous</option>
                <option value="initial">Envoi initial</option>
                <option value="resend">Renvoi</option>
            </Form.Select>
        </Form.Group>
    );
});

export default SendingType;